export default function (link) {
    return /^\/(?!\/)/.test(link) && !link.includes("#");
}
